const leadWonCharts = {
  series: [
    {
      data: [400, 122, 250],
    },
  ],
  wonCharts: {
    chart: {
      type: "bar",
      height: 150,
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#5CB85C"],
    xaxis: {
      categories: ["Conversation", "Follow Up", "Inpipeline"],
    },
  },
};

const PriorityLeadpieChart = {
    pieCharts: {
    chart: {
      width: 450,
      type: "pie",
    },
    labels: [],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 275,
          },
          legend: {
            position: "right",
          },
        },
      },
    ],
  },
};


const contactAnalysisCharts = {
  series: [44, 55, 41, 17],
  contactCharts: {
    chart: {
      type: "donut",
    },
    colors: ["#4A00E5", "#FFA201", "#0092E4", "#E41F07"],
    labels: ["BuildEx", "HVACR & Cold Chain", "RenEx", "BPLX"],
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      position: "bottom",
      formatter: function (val, opts) {
        return val + " - " + opts.w.globals.series[opts.seriesIndex];
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  },
};
const projectStaChartscopy = {
  series: [
    {
      name: "test",
      data: [1200, 1000, 800, 600, 400, 200],
    },
  ],
  stagesCharts: {
    chart: {
      type: "bar",
      height: 420,
    },

    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
        distributed: true,
        barHeight: "100%",
        isFunnel: true,
      },
    },
    colors: ["#4A00E5", "#1ECBE2", "#FF9D0A", "#00918E", "#5CB85C", "#FC0027"],

    dataLabels: {
      enabled: true,
      formatter: function (val, opt) {
        return opt.w.globals.labels[opt.dataPointIndex];
      },
      dropShadow: {
        enabled: true,
      },
    },
    xaxis: {
      categories: [
        "	New Leads",
        "Initial Contact",
        "Material Shared",
        "Visited",
        "On Followup",
        "Lead Won",
      ],
    },
    legend: {
      show: false,
    },
  },
};

const projectStaCharts = {
  series: [
    {
      name: "Leads",
      data: [1200, 1000, 800, 600, 400, 200], // 🔹 VALUES
    },
  ],

  stagesCharts: {
    chart: {
      type: "bar",
      height: 420,
    },

    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        barHeight: "100%",
        isFunnel: true, // ⭐ funnel behavior
      },
    },

    colors: [
      "#4A00E5",
      "#1ECBE2",
      "#FF9D0A",
      "#00918E",
      "#5CB85C",
      "#FC0027",
    ],

    dataLabels: {
      enabled: true,
      formatter: function (val, opt) {
        // 👇 LABEL + VALUE
        const label = opt.w.globals.labels[opt.dataPointIndex];
        return `${label}: ${val}`;
      },
      dropShadow: {
        enabled: true,
      },
    },

    xaxis: {
      categories: [
        "New Leads",
        "Initial Contact",
        "Material Shared",
        "Visited",
        "On Followup",
        "Lead Won",
      ], // 🔹 LABELS
    },

    legend: {
      show: false,
    },
  },
};

const lastProCharts = {
  series: [
    {
      data: [400, 220, 448],
    },
  ],
  lastCharts: {
    chart: {
      type: "bar",
      height: 150,
    },

    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#FC0027"],
    xaxis: {
      categories: ["Conversation", "Follow Up", "Inpipeline"],
    },
  },
};
const wonProCharts = {
  series: [
    {
      data: [400, 122, 250],
    },
  ],
  wonCharts: {
    chart: {
      type: "bar",
      height: 150,
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#5CB85C"],
    xaxis: {
      categories: ["Conversation", "Follow Up", "Inpipeline"],
    },
  },
};
const contactReportChart = {
  series: [
    {
      name: "Leads",
      data: [40, 30, 20, 30, 22, 20, 30, 20, 22, 30, 15, 20],
    },
  ],

  reportCharts: {
    chart: {
      height: 273,
      type: "bar",   // ✅ BAR CHART
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false
      }
    },

    plotOptions: {
      bar: {
        columnWidth: "45%",   // control bar width
        borderRadius: 4,      // smooth edges
        distributed: false
      }
    },

    colors: ["#4A00E5"],

    dataLabels: {
      enabled: false,
    },

    xaxis: {
      categories: [
        "Jan","Feb","Mar","Apr","May","Jun",
        "Jul","Aug","Sep","Oct","Nov","Dec"
      ],
    },

    yaxis: {
      min: 10,
      max: 60,
      tickAmount: 5,
    },

    grid: {
      strokeDashArray: 4
    },

    legend: {
      show: false
    }
  },
};

const employeeWiseChart = {
  series: [
    {
      name: "Leads",
      data: [120, 95, 80, 70, 60, 45],
    },
  ],

  chartOptions: {
    chart: {
      type: "bar",
      height: 350,
      toolbar: { show: false },
    },

    plotOptions: {
      bar: {
        horizontal: true,   // ⭐ Horizontal bar
        barHeight: "55%",
        borderRadius: 4,
      },
    },

    colors: ["#26CECC"],

    dataLabels: {
      enabled: true,
      style: {
        colors: ["#fff"],
      },
    },

    // 👇 EMPLOYEE NAMES GO HERE
    xaxis: {
      categories: [
        "Rakib",
        "Hasan",
        "Sajid",
        "Imran",
        "Nayeem",
        "Shuvo",
      ],
      title: {
        text: "Employees",
      },
    },

    // 👇 Numeric axis (auto)
    yaxis: {
      title: {
        text: "Leads Count / Time Range",
      },
    },

    grid: {
      strokeDashArray: 4,
    },
  },
};
const multiLineChart = {
  series: [
    {
      name: "Leads",
      data: [40, 30, 20, 30, 22, 20, 30, 20, 22, 30, 15, 20],
    },
    {
      name: "Closed",
      data: [20, 18, 15, 20, 14, 12, 18, 15, 16, 22, 10, 14],
    },
    {
      name: "Lost",
      data: [10, 12, 8, 10, 9, 8, 12, 10, 11, 13, 7, 9],
    },
  ],

  chartOptions: {
    chart: {
      type: "line",
      height: 320,
      toolbar: { show: false },
    },

    stroke: {
      width: 3,
      curve: "smooth",   // ⭐ smooth lines
    },

    markers: {
      size: 4,
    },

    colors: ["#4A00E5", "#28C76F", "#EA5455"],

    xaxis: {
      categories: [
        "Jan","Feb","Mar","Apr","May","Jun",
        "Jul","Aug","Sep","Oct","Nov","Dec"
      ],
    },

    yaxis: {
      title: {
        text: "Count",
      },
    },

    legend: {
      position: "top",
      horizontalAlign: "left",
    },

    grid: {
      strokeDashArray: 4,
    },

    tooltip: {
      shared: true,
      intersect: false,
    },
  },
};





export { contactReportChart,leadWonCharts,PriorityLeadpieChart,contactAnalysisCharts, projectStaCharts, lastProCharts, wonProCharts,employeeWiseChart,multiLineChart };
